import { styled } from '@mui/material/styles';

export const Bid = styled('span')(({ theme }) => ({
  ...theme.typography.body2,
  fontSize: '0.725rem',
  lineHeight: '1.025rem',
  margin: 0,
}));
